import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

export const initialState = {
  onboarding: {
    selectedPlan: undefined,
    selectedCpdCategorys: []
  }
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('onboarding')(configurations),
}, {
    ...initialState
  }
);

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/global/reducers.js